import React from 'react';
import { RichTextEditor } from '../../../../../../components/RichTextEditor';
import { CreateEmailDto } from '../../CreateEmailDto';
import { Control } from 'react-hook-form';
import { EmailTemplate } from '../../../../../../entities/EmailTemplate';
import { UpdateStatePlugin } from '../../../../../../components/RichTextEditor/plugins/UpdateStatePlugin';
import { AreaRichTextComposer } from '../../../../../../components/RichTextEditor/composers/AreaRichTextComposer';

interface PropTypes {
  emailTemplate?: EmailTemplate;
  control: Control<CreateEmailDto, any>;
  onChangeHtml: (html: string) => void;
}

export function EmailRichTextEditor(props: PropTypes) {
  return (
    <div>
      <RichTextEditor<CreateEmailDto>
        formHookContext={{
          controllerName: 'editorState',
          formControl: props.control,
          required: true,
        }}
        render={(field) => (
          <AreaRichTextComposer
            externalPlugins={[
              <UpdateStatePlugin
                key={1}
                editorState={props.emailTemplate?.template}
              />,
            ]}
            onChangeJson={(value: string) => field.onChange(value)}
            onChangeHtml={props.onChangeHtml}
            size='sm'
          />
        )}
      />
    </div>
  );
}
